import { path } from 'd3-path'
import Symbol2d from '../2d.js'
import {textContainer} from './helpers/parallelogram.js'

export default class LeftParallelogram extends Symbol2d {

  handles = [{
    defaults: [.8, 0], // 20% of the width, but the handle is on the right side
    constraints: [
      [.5, 1], null
    ],
    cursor: 'ew-resize'
  }]

  path (dimensions, handles) {
    const _path = path()
    const offset = dimensions.width - (dimensions.width * handles[0][0])

    _path.moveTo(0, 0)
    _path.lineTo(dimensions.width - offset, 0)
    _path.lineTo(dimensions.width, dimensions.height)
    _path.lineTo(offset, dimensions.height)
    _path.closePath()

    return _path.toString()
  }

  textContainer (dimensions, handles) {
    const offset = dimensions.width - (dimensions.width * handles[0][0])
    return textContainer(dimensions, offset)
  }

}
